import React from 'react';
import styled from 'styled-components';

//LAYOUT
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container';


//ICONS
import { ChevronUp } from '../../../components-core/packages/icons-core/dist/ChevronUp';


const ClickableDiv = styled.div`
    background-color: ${props => props.backgroundColor && props.backgroundColor};
    transition: background-color 0.2s ease;
    cursor: pointer;
    
`;

const AnimatedIconContainer = styled.div`
    transform: ${props => props.isOpen ? 'rotateX(180deg)' : 'rotateX(0)'};
    transition: transform 0.4s ease;
`;

const AnimatedTwoLineIconContainer = styled.div`
transform: ${props => props.isOpen ? 'rotateX(180deg)' : 'rotateX(0)'};
transition: transform 0.4s ease;
margin-right:-45px;
`;

const Line = styled.div`
    width: 100%;
    height: 2px;
    background-color: #dfe4e8;
`;

class CustomAccordion extends React.Component {

    constructor() {
        super();
        this.state = {
            isOpened: false
        }
    }

    render() {
        const { isOpened } = this.state
        const {
            children,
            backgroundColor,
            title,
            onClick,
            line,
            horizontalPadding,
            linePadding,
            isOpen
        } = this.props;

        let finalIsOpen = false;

        if (isOpen) {
            finalIsOpen = isOpen;
        } else {
            finalIsOpen = isOpened;
        }

        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <Container
                    verticalAlign={ContainerVerticalAlignment.center}
                    wrap={ContainerWrap.always}
                >
                    <ClickableDiv
                        onClick={() => { onClick(); this.setState({ isOpen: !isOpen }) }}
                        backgroundColor={backgroundColor}
                        verticalAlign={ContainerVerticalAlignment.center}
                    >
                        <Container
                            padding={{
                                top: ContainerPadding.dynamic0100,
                                bottom: ContainerPadding.dynamic0050,
                                left: horizontalPadding && horizontalPadding,
                                right: horizontalPadding && horizontalPadding
                            }}
                            horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                            verticalAlign={ContainerVerticalAlignment.center}
                            wrap={ContainerWrap.never}
                        >
                            {title}
                           {(title.length <30) ? <AnimatedIconContainer isOpen={isOpen}><ChevronUp/></AnimatedIconContainer>  : <AnimatedTwoLineIconContainer isOpen={isOpen}><ChevronUp/></AnimatedTwoLineIconContainer>}
                        </Container>
                        <Container
                            stretchContent
                            padding={{
                                left: linePadding && linePadding,
                                right: linePadding && linePadding
                            }}
                        >
                            {line && !isOpen && <Line />}
                        </Container>
                    </ClickableDiv>
                </Container>
                {isOpen ? children : isOpen ? children : undefined}
            </Container>
        )
    }

}

export default CustomAccordion;